import ArticleBodyContentContext from '@contexts/articleBodyContent'
import { useContext } from 'react'

const useIsInArticleBodyContent = (): boolean =>
  !!useContext(ArticleBodyContentContext)

export default useIsInArticleBodyContent
